export const normalClassTags = ['REGULAR', 'EXTRA'];
export const demoClassTag = ['DEMO'];

export const autoMappingStates = {
  AUTO_MAPPED: 'AUTO_MAPPED',
  MANUAL_MAPPED: 'MANUAL_MAPPED',
  PENDING: 'PENDING',
  FAILED: 'FAILED',
};

export const prePrimaryGrades = {
  [-1]: 'Pre-KG',
  0: 'KG',
};

export const postPrimaryGrades = {
  1: 'I',
  2: 'II',
  3: 'III',
  4: 'IV',
  5: 'V',
  6: 'VI',
  7: 'VII',
  8: 'VIII',
  9: 'IX',
  10: 'X',
  11: 'XI',
  12: 'XII',
};

export const GRADES = { ...prePrimaryGrades, ...postPrimaryGrades };

export const studentCredentialLabel = {
  USERNAME: 'Username',
  PASSWORD: 'Password',
};
export const REDIRECT_CONSTANTS = { REDIRECT_URL: 'redirectURL', HOME_ROUTE: '/' };

export const MONTHS = Object.freeze([
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]);

export const USER_SELECT_DISABLE_ARRAY = ['email', 'username', 'phone'];
